<template>
  <div>
    <Row class="reset">
      <Tabs value="1">
        <TabPane label="使用手机号重置密码" name="1" icon="md-phone-portrait" v-if="type == '0'"> </TabPane>
        <TabPane label="使用邮箱重置密码" name="1" icon="ios-mail-outline" v-else> </TabPane>
      </Tabs>
      <Form ref="resetForm" :model="form" :rules="rules" class="form">
        <div v-if="type == '0'">
          <FormItem prop="mobile" :error="errorMobile">
            <Input v-model="form.mobile" size="large" clearable placeholder="请输入注册或绑定的手机号"></Input>
          </FormItem>
          <FormItem prop="code">
            <Row type="flex" justify="space-between">
              <Input v-model="form.code" size="large" clearable placeholder="请输入短信验证码" :maxlength="10" class="input-verify" />
              <Button size="large" :loading="sending" @click="sendSmsVerifyCode" v-if="!sended" class="send-verify">
                <span v-if="!sending">获取验证码</span>
                <span v-else>发送中</span>
              </Button>
              <Button size="large" disabled v-if="sended" class="count-verify">{{ countButton }}</Button>
            </Row>
          </FormItem>
          <Button @click="handleViewUserList" size="large" :loading="loadingUser" style="width: 100%;margin-bottom: 25px" type="primary">查看手机号关联账号</Button>
        </div>
        <div v-else>
          <FormItem prop="email" :error="errorEmail">
            <Input v-model="form.email" size="large" clearable placeholder="请输入绑定邮箱"></Input>
          </FormItem>
          <FormItem prop="code">
            <Row type="flex" justify="space-between">
              <Input v-model="form.code" size="large" clearable placeholder="请输入您收到的邮件中的验证码" :maxlength="10" class="input-verify" />
              <Button size="large" :loading="sending" @click="sendEmailVerifyCode" v-if="!sended" class="send-verify">
                <span v-if="!sending">发送验证码</span>
                <span v-else>发送中</span>
              </Button>
              <Button size="large" disabled v-if="sended" class="count-verify">{{ countButton }}</Button>
            </Row>
          </FormItem>
        </div>
        <!-- <FormItem prop="password">
          <Poptip trigger="focus" placement="right" width="250">
            <Input type="password" :maxlength="20" v-model="form.password" @on-change="strengthChange" size="large" clearable placeholder="请输入密码，长度为6-20个字符" />
            <div v-bind:class="tipStyle" slot="content">
              <span class="words">强度 : {{ strength }}</span>
              <Slider v-model="strengthValue" :step="33" style="width:95%"></Slider>
              请至少输入 6 个字符。请不要使<br />用容易被猜到的密码。
            </div>
          </Poptip>
        </FormItem>
        <FormItem prop="confirmPass">
          <Input type="password" :maxlength="20" v-model="form.confirmPass" size="large" clearable placeholder="请再次输入确认密码" />
        </FormItem> -->
      </Form>

      <!-- <Button style="margin-bottom:3vh" type="primary" size="large" :loading="loading" @click="submitReset" long>重置密码</Button> -->
      <slot name="back"></slot>
      <!-- <Row type="flex">
        <a @click="backLogin" class="back"> <Icon type="md-arrow-round-back" style="margin-bottom:3px;" /> 返回</a>
      </Row> -->
    </Row>
    <!-- 账号列表 -->
    <Modal v-model="userModelList" width='700' closable :mask-closable='false' footer-hide>
      <Table border :columns="columnsUser" :data="userList" style="margin-top: 25px">
        <template slot-scope="{ row }" slot="action">
            <Button type="primary" size="small" @click="handleChangePassword(row)">修改密码</Button>
        </template>
      </Table>
    </Modal>
    <!-- 修改密码 -->
    <Modal v-model="changeModel" closable :mask-closable='false' footer-hide>
      <Form ref="editPasswordForm" :model="editPasswordForm" :label-width="100" label-position="right" :rules="passwordValidate" style="width:450px;margin-top: 25px">
        <FormItem label="新密码" prop="password">
          <Input type="password" v-model="editPasswordForm.password" placeholder="请输入新密码，长度为6-20个字符" />
        </FormItem>
        <FormItem label="确认新密码" prop="confirmPass">
          <Input type="password" v-model="editPasswordForm.confirmPass" placeholder="请再次输入新密码" />
        </FormItem>
        <FormItem>
          <Button type="primary" style="width: 100px;margin-right:5px" :loading="savePassLoading" @click="handleSaveEditPass">保存</Button>
          <Button @click="changeModel = false">取消</Button>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>
<script>
import { getRequest, postRequest } from '@/libs/axios'
import { vaptchaID, sendResetSms, resetByMobile, sendResetEmail, resetByEmail } from '@/api/index'
// import Cookies from 'js-cookie'
import util from '@/libs/util'
var vaptchaObject
export default {
  props: {
    type: {
      type: String,
      default: null
    }
  },
  data() {
    const validatePassword = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error('密码长度不得小于6位'))
      } else {
        callback()
      }
    }
    const validateConfirmPass = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error('密码长度不得小于6位'))
      } else if (value !== this.form.password) {
        callback(new Error('两次输入的密码不一致'))
      } else {
        callback()
      }
    }
    const valideRePassword = (rule, value, callback) => {
      if (value !== this.editPasswordForm.password) {
        callback(new Error('两次输入密码不一致'))
      } else {
        callback()
      }
    }
    return {
      savePassLoading: false,
      userId: '',
      editPasswordForm: {
        password: '',
        confirmPass: '',
      },
      passwordValidate: {
        password: [
          {
            required: true,
            message: '请输入新密码',
            trigger: 'blur'
          },
          {
            min: 6,
            message: '请至少输入6个字符',
            trigger: 'blur'
          },
          {
            max: 32,
            message: '最多输入32个字符',
            trigger: 'blur'
          }
        ],
        confirmPass: [
          {
            required: true,
            message: '请再次输入新密码',
            trigger: 'blur'
          },
          {
            validator: valideRePassword,
            trigger: 'blur'
          }
        ]
      },
      changeModel: false,
      columnsUser: [
        {
          title: '真实姓名',
          key: 'realName',
          minWidth: 100,
          align: "center",
          tooltip: true
        },
        {
          title: '登录名',
          key: 'username',
          width: 100,
          align: "center",
          tooltip: true
        },
        {
          title: '机构名',
          key: 'organizationName',
          width: 120,
          align: "center",
          tooltip: true
        },
        {
          title: '注册时间',
          key: 'registerTime',
          width: 200,
          align: "center",
          render(h,data) {
            return h('div', util.dateFormat(data.row.registerTime))
          },
        },
        {
          title: "操作",
          key: "action",
          width: 100,
          fixed: "right",
          slot: "action"
        }
      ],
      userList: [],
      userModelList: false,
      loadingUser: false,
      //   label: '使用手机号重置密码',
      //   icon: 'md-phone-portrait',
      loading: false,
      //   type: '0',
      form: {
        mobile: '',
        email: '',
        token: '',
        password: '',
        passStrength: ''
      },
      sended: false,
      sending: false,
      count: 60,
      countButton: '60 s',
      tipStyle: 'password-tip-none',
      strength: '无',
      select: '86',
      strengthValue: 0,
      errorMobile: '',
      errorEmail: '',
      rules: {
        mobile: [
          {
            required: true,
            message: '手机号不能为空',
            trigger: 'blur'
          }
        ],
        email: [
          {
            required: true,
            message: '请输入邮箱地址',
            trigger: 'blur'
          },
          {
            type: 'email',
            message: '邮箱格式不正确',
            trigger: 'blur'
          }
        ],
        password: [
          {
            required: true,
            message: '密码不能为空',
            trigger: 'blur'
          },
          {
            validator: validatePassword,
            trigger: 'blur'
          }
        ],
        code: [
          {
            required: true,
            message: '验证码不能为空',
            trigger: 'blur'
          }
        ],
        confirmPass: [
          {
            required: true,
            message: '确认密码不能为空',
            trigger: 'blur'
          },
          {
            validator: validateConfirmPass,
            trigger: 'blur'
          }
        ]
      }
    }
  },
  watch:{
    changeModel(){
      if(!this.changeModel){
        this.userId = '';
      };
    },
  },
  methods: {
    // 确定修改
    handleSaveEditPass(){
      this.$refs.editPasswordForm.validate(async valid => {
        if (valid) {
          // 发送短信验证码
          this.savePassLoading = true;
          const result = await postRequest('/v3/student/resetPassword', { ...this.editPasswordForm, userId: this.userId }, true);
          this.savePassLoading = false;
          if (result.success) {
            this.$Message.success(result.message);
            this.changeModel = false;
          };
        }
      })
    },
    // 修改密码
    handleChangePassword(row){
      this.changeModel = true;
      this.userId = row.userId;
    },
    // 查看关联账号
    async handleViewUserList(){
      const { mobile, code } = this.form;
      if(!mobile){
        this.$Message.warning('请输入手机号');
        return;
      };
      if(!code){
        this.$Message.warning('请输入验证码');
        return;
      };
      this.loadingUser = true;
      const data = await postRequest('/v3/student/getUserInfoByMobile', { mobile, verifyCode: code }, true);
      this.loadingUser = false;
      if (data.success) {
        this.userList = data.result;
        this.userModelList = true;
        this.$emit('handleResetModal');
      };
    },
    initVaptcha() {
      let that = this
      vaptcha({
        // 配置参数
        vid: vaptchaID, // 验证单元id
        type: 'invisible' // 展现类型 隐藏式
      }).then(function(vaptchaObj) {
        vaptchaObject = vaptchaObj
        vaptchaObj.listen('pass', function() {
          that.form.token = vaptchaObj.getToken()
          // 发送验证码
          if (that.type == '0') {
            that.sendSmsVerifyCode()
          } else if (that.type == '1') {
            that.sendEmailVerifyCode()
          }
        })
      })
    },
    checkStrengthValue(v) {
      // 评级制判断密码强度 最高5
      let grade = 0
      if (/\d/.test(v)) {
        grade++ //数字
      }
      if (/[a-z]/.test(v)) {
        grade++ //小写
      }
      if (/[A-Z]/.test(v)) {
        grade++ //大写
      }
      if (/\W/.test(v)) {
        grade++ //特殊字符
      }
      if (v.length >= 10) {
        grade++
      }
      return grade
    },
    strengthChange() {
      if (!this.form.password) {
        this.tipStyle = 'password-tip-none'
        this.strength = '无'
        this.strengthValue = 0
        return
      }
      let grade = this.checkStrengthValue(this.form.password)
      if (grade <= 1) {
        this.tipStyle = 'password-tip-weak'
        this.strength = '弱'
        this.strengthValue = 33
      } else if (grade >= 2 && grade <= 4) {
        this.tipStyle = 'password-tip-middle'
        this.strength = '中'
        this.strengthValue = 66
      } else {
        this.tipStyle = 'password-tip-strong'
        this.strength = '强'
        this.strengthValue = 100
      }
    },
    showVaptcha() {
      if (this.type == '0') {
        var reg = /^[1][3,4,5,6,7,8][0-9]{9}$/
        if (!reg.test(this.form.mobile)) {
          this.errorMobile = '手机号格式错误'
          return
        } else {
          this.errorMobile = ''
        }
      } else if (this.type == '1') {
        var reg = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/
        if (!reg.test(this.form.email)) {
          this.errorEmail = '邮箱格式错误'
          return
        } else {
          this.errorEmail = ''
        }
      }
      // vaptchaObject.validate(); // 若没验证验证码 开始验证
    },
    async sendSmsVerifyCode() {
      if(!this.form.mobile){
        this.$Message.warning('请输入手机号');
        return;
      };
      this.sending = true;
      const result = await getRequest('/v3/student/sendSms/' + this.form.mobile, {}, true)
      this.sending = false
      if (result.success) {
        this.$Message.success('发送短信验证码成功')
        this.sended = true
        this.countDown()
      };
    },
    sendEmailVerifyCode() {
      this.sending = true
      sendResetEmail(this.form).then(res => {
        this.sending = false
        // vaptchaObject.reset();
        if (res.success) {
          this.$Message.success('发送邮件验证码成功，请注意查收')
          this.sended = true
          this.countDown()
        }
      })
    },
    countDown() {
      let that = this
      if (this.count == 0) {
        this.sended = false
        this.count = 60
        return
      } else {
        this.countButton = this.count + ' s'
        this.count--
      }
      setTimeout(function() {
        that.countDown()
      }, 1000)
    },
    submitReset() {
      this.$refs.resetForm.validate(valid => {
        if (valid) {
          this.form.passStrength = this.strength
          this.loading = true
          if (this.type == '0') {
            resetByMobile(this.form).then(res => {
              this.loading = false
              if (res.success) {
                this.$Message.success('重置密码成功，请牢记您的新密码')
                this.$router.push({
                  name: 'login'
                })
              }
            })
          } else if (this.type == '1') {
            resetByEmail(this.form).then(res => {
              this.loading = false
              if (res.success) {
                this.$Message.success('重置密码成功，请牢记您的新密码')
                this.$router.push({
                  name: 'login'
                })
              }
            })
          }
        }
      })
    }
  },
  created() {
    // let type = this.$route.query.type
    // let type = util.localGet('typeResetPassWord')
    // if (this.type === '1') {
    // //   this.type = type
    //   this.label = '使用邮箱重置密码'
    //   this.icon = 'ios-mail-outline'
    // } else {
    // //   this.type = '0'
    //   this.label = '使用手机号重置密码'
    // }
    // console.log(this.type, 'this.type')
  }
}
</script>
<style lang="less" scoped>
.ivu-btn-large{
  font-size: 14px;
}
.reset {
  margin-bottom: 8vh;
  .form {
    padding-top: 1vh;
  }
  .input-verify {
    width: 70%;
  }
  .count-verify,
  .send-verify {
    width: 100px;
  }
  .ivu-poptip {
    display: inline-block;
    width: 100%;
  }
  .ivu-poptip-rel {
    width: 100%;
    display: inline-block;
    position: relative;
  }
  .ivu-slider-button {
    display: none;
  }
  .ivu-slider-button-wrap .ivu-tooltip {
    display: none;
  }
  .password-tip-none {
    padding: 1vh 0;
    font-size: 14px;
    .ivu-slider-bar {
      height: 4px;
      border-radius: 3px;
      position: absolute;
    }
  }
  .password-tip-weak {
    padding: 1vh 0;
    font-size: 14px;
    .words {
      color: #ed3f14;
    }
    .ivu-slider-bar {
      height: 4px;
      background: #ed3f14;
      border-radius: 3px;
      position: absolute;
    }
  }
  .password-tip-middle {
    padding: 1vh 0;
    font-size: 14px;
    .words {
      color: #faad14;
    }
    .ivu-slider-bar {
      height: 4px;
      background: #faad14;
      border-radius: 3px;
      position: absolute;
    }
  }
  .password-tip-strong {
    padding: 1vh 0;
    font-size: 14px;
    .words {
      color: #52c41a;
    }
    .ivu-slider-bar {
      height: 4px;
      background: #52c41a;
      border-radius: 3px;
      position: absolute;
    }
  }
  .back {
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/student/components/mobileResetPassword.vue